// TransactionDetailsDialog.js
import React from 'react';
import { CircularProgress } from '@mui/material';
import CustomDialog from 'widgets/component/CustomDialog';
import DataTableDetailOrder from 'widgets/customDialogComponentDetails/ComponentDialog';
import { CircularProgressStyle } from '../style/style';

const TransactionDetailsStripe = ({
  open,
  onClose,
  loading,
  detailTransactionsStripe,
  handleOpenPopUp,
  setOpenActionFraud,
  setIdReverso,
  setActiveAction,
  setShouldReturnData,
  activeAction,
  shouldReturnData,
}) => (
  <CustomDialog
    fullWidth
    title={
      detailTransactionsStripe?.response?.payment_info === null
        ? 'No hay datos'
        : 'Transacción Stripe'
    }
    content={
      loading ? (
        <CircularProgress sx={CircularProgressStyle.CircularProgress} />
      ) : (
        <DataTableDetailOrder
          namePayment='Stripe'
          type='detailsStripe'
          handleOpenPopUp={handleOpenPopUp}
          setOpenActionFraud={setOpenActionFraud}
          response={detailTransactionsStripe?.response}
          idTransaction={detailTransactionsStripe?.response?.transaction_type?.transaction_id}
          onClose={onClose}
          setIdReverso={setIdReverso}
          setActiveAction={setActiveAction}
          setShouldReturnData={setShouldReturnData}
          activeAction={activeAction}
          shouldReturnData={shouldReturnData}
        />
      )
    }
    open={open}
    onClose={onClose}
    maxWidth='md'
    extraButtons={[
      {
        label: 'Aceptar',
        variant: 'contained',
        onClick: onClose,
        buttonColor: 'purple',
        textColor: 'white',
      },
    ]}
  />
);

export default TransactionDetailsStripe;
